'use client';

import { Containers, Widgets } from '@/components';
import { USE_CASES_OVERVIEW_HERO } from '@/utils/content/useCasesOverviewHero';

export default function UseCasesOverview() {
    const hero = USE_CASES_OVERVIEW_HERO;

    return (
        <>
            <Containers.Section
                el={
                    <Widgets.UseCasesOverviewHero
                        tag={hero.tag}
                        title={hero.title}
                        titleLine2={hero.titleLine2}
                        description={hero.description}
                        secondaryDescription={hero.secondaryDescription}
                        image={hero.image}
                        imageAlt={hero.imageAlt}
                        imagePriority
                    />
                }
            />
            <Containers.Section el={<Widgets.UseCasesOverviewCards />} />
            <Containers.Section el={<Widgets.ReadToBuild />} />
        </>
    );
}
